import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { trackPageLoad } from '../helpers/tracking';
import { getGTAGRgpdOptions } from '../selectors/rgpd';
import { Page } from '../types/page/page';

export type TrackingEventHandler = (
  trackingInfos: Record<string, string>
) => Record<string, string> | undefined;

const usePageLoadTracking = (
  page: Page,
  onPageLoadTracking: TrackingEventHandler = (
    options
  ): Record<string, string> => options
): void => {
  const shouldTrack = useSelector(getGTAGRgpdOptions);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (shouldTrack && page?.type) {
      const trackingInfos = onPageLoadTracking({
        page_name: page.title,
        page_categorie: page.type.toLowerCase(),
      });

      trackPageLoad(trackingInfos, i18n.language);
    }
  }, [shouldTrack, i18n.language, page?.type]);
};

export default usePageLoadTracking;
